import { Component } from 'react';

export default class OutsideClick extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      clickOutside: false,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  private wrapperRef: any;
  public componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  public setWrapperRef(node: any) {
    this.wrapperRef = node;
  }

  public handleClickOutside(event: any) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.clickedOutside();
    }
  }

  public render() {
    return <div ref={this.setWrapperRef}>{this.props.render(this.state)}</div>;
  }
}



// WEBPACK FOOTER //
// ./components/common/OutsideClick.tsx